import { ReactElement } from 'react';

import MergeStatusDropdown from './MergeStatusDropdown';
import useTexts from '../hooks/useTexts';
import MergeOptions from './MergeOptions';
import MergeReason from './MergeReason';
import { MergeContentWrapper, LeftSideWrapper, StyledSecondaryTitle, StyledText, StyledContainer } from '../style';

const MergeDetails = (): ReactElement => {
  const { includeInPrimarySR, selectPrimaryTicket } = useTexts();

  return (
    <StyledContainer>
      <StyledSecondaryTitle>{includeInPrimarySR}</StyledSecondaryTitle>
      <MergeContentWrapper>
        <LeftSideWrapper>
          <StyledText>{selectPrimaryTicket}</StyledText>
          <MergeOptions />
          <MergeStatusDropdown />
        </LeftSideWrapper>
        <MergeReason />
      </MergeContentWrapper>
    </StyledContainer>
  );
};

export default MergeDetails;
